import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { DiversificationResponse } from 'src/app/models/diversification-response.model'

@Injectable({
  providedIn: 'root',
})
export class DiversificationService {
  public static readonly diversificationEndpoint = '/diversification'

  constructor(private readonly http: HttpClient) {}

  getDiversification(
    fundId: string,
    isInternal: boolean,
    isBfpDiversificationToggle: boolean,
  ): Observable<DiversificationResponse> {
    const params = new HttpParams()
      .set('isInternal', String(isInternal))
      .set('isBfpDiversificationToggle', String(isBfpDiversificationToggle))
    return this.http.get<DiversificationResponse>(
      `vmf/api/${fundId}`.concat(
        DiversificationService.diversificationEndpoint,
      ),
      { params },
    )
  }
}
